<template>
    <div class="bg-white p-4 sm:p-6 lg:p-8 rounded-lg shadow-lg w-full max-w-lg lg:max-w-6xl mb-8">
      <h2 class="text-lg sm:text-xl lg:text-2xl font-bold mb-4 text-gray-800">Manage Deliveries</h2>
  
      
  
      <!-- Items Table -->
      <table class="w-full text-left border-collapse">
        <thead>
          <tr>
            <th class="p-2 border-b-2">Date</th>
            <th class="p-2 border-b-2">Client</th>
            <th class="p-2 border-b-2">Staff</th>
            <th class="p-2 border-b-2">Total (FRw)</th>
            <th class="p-2 border-b-2">Status</th>
            <th class="p-2 border-b-2">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(delivery, index) in deliveries" :key="index" class="hover:bg-gray-100">
            <td class="p-2 border-b">{{ formatDate(delivery.createdAt) }}</td>
            <td class="p-2 border-b">{{ delivery?.client?.name }}</td>
            <td class="p-2 border-b">{{ delivery?.staff?.name }}</td>
            <td class="p-2 border-b">{{ +delivery.order.totalAmount }}</td>
            <td class="p-2 border-b">{{ delivery.status }}</td>
            <td class="p-2 border-b">
            <button @click="viewDelivery(delivery)" class="text-blue-500 hover:text-blue-700 focus:outline-none px-2">
              <i class="fas fa-eye"></i>
            </button>
            <button @click="editDelivery(delivery)" class="text-gray-500 hover:text-gray-700 focus:outline-none px-2">
              <i class="fa fa-paper-plane"></i>
            </button>
          </td>
          </tr>
          <tr v-if="deliveries.length === 0">
            <td colspan="5" class="text-center text-gray-500 p-4">No deliveries available.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Modals -->
    <AddDeliveryModal v-if="isAddDeliveryModalOpen" @closeModal="isAddDeliveryModalOpen = false" />
    <ViewDeliveryModal v-if="isViewDeliveryModalOpen" :delivery="selectedDelivery" @closeModal="isViewDeliveryModalOpen = false" />
    <EditDeliveryModal v-if="isEditDeliveryModalOpen" :delivery="selectedDelivery" @closeModal="isEditDeliveryModalOpen = false" />
  </template>
  
  <script>
  import { mapState, mapActions } from 'vuex';

  import ViewDeliveryModal from '@/views/deliveries/ViewDeliveryModal.vue';
  import EditDeliveryModal from '@/views/deliveries/EditDeliveryModal.vue';
  export default {
    components: {
      ViewDeliveryModal,
      EditDeliveryModal,
    },
    data() {
    return {
      isAddDeliveryModalOpen: false,
      isViewDeliveryModalOpen: false,
      isEditDeliveryModalOpen: false,
      selectedDelivery: null,
    };
  },
    async mounted(){
      await this.fetchDeliveries();
    },
    computed : {
    ...mapState('deliveries', {
      deliveries: state => state.deliveries,
    })
    },
    methods: {
      ...mapActions('deliveries', {
        fetchDeliveries : 'fetchDeliveries',
        editDelovery : 'editDelivery',
      }),
      viewDelivery(delivery) {
        this.selectedDelivery = delivery;
        this.isViewDeliveryModalOpen = true;
      },
      editDelivery(delivery) {
        this.selectedDelivery = delivery;
        this.isEditDeliveryModalOpen = true;
      },
      formatDate(date) {
        return new Date(date).toLocaleDateString();
      },
    }
  };
  </script>
  